
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'6-1'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>
            주문 / 배송 관리 - 주문 현황 {{ $route.query.order_ID === undefined ? '등록' : '수정' }}
          </p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn01" v-on:click="check_form">
              {{ $route.query.order_ID === undefined ? '등록' : '수정' }}
            </button>
          </div>
        </div>

        <div class="Admin_PageDetail">

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='order_receive_name'>받는사람<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'order_receive_name'
                maxLength="150"
                placeholder = "받는사람을 입력해 주세요."
                v-model="formData.orderReceiveName"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.orderReceiveNameError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='order_zip_code'>우편번호(클릭)<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                id = 'order_zip_code'
                v-model="formData.orderZipCode"
                maxlength="10"
                placeholder="클릭 시 검색"
                readonly
                v-on:click="search_address"
              />
            </div>
            <p class="Admin_ErrorBox"></p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='order_road_address'>도로명 주소(클릭)<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                id = 'order_road_address'
                v-model="formData.orderRoadAddress"
                maxlength="150"
                placeholder="클릭 시 검색"
                readonly
                v-on:click="search_address"
              />
            </div>
            <p class="Admin_ErrorBox"></p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='order_detail_address'>상세 주소</label>
              <input
                class="Admin_PageDetail_inputText"
                id = 'order_detail_address'
                v-model="formData.orderDetailAddress"
                maxlength="150"
                placeholder="상세주소를 입력해주세요."
              />
            </div>
            <p class="Admin_ErrorBox"></p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='order_phone_number'>전화번호<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'order_phone_number'
                maxLength="13"
                placeholder = "전화번호를 입력해 주세요."
                v-model="formData.orderPhoneNumber"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.orderPhoneNumberError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='order_email'>이메일<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'order_email'
                maxLength="50"
                placeholder = "이메일을 입력해 주세요."
                v-model="formData.orderEmail"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.orderEmailError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='order_message'>배송메세지<span class="pointTextRed">(수정불가)</span></label>
              <textarea
                class="Admin_PageDetail_textarea"
                id="order_memo"
                maxLength="500"
                rows="10"
                readonly
                v-model="statusData.orderMessage"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='order_memo'>관리자메모</label>
              <textarea
                class="Admin_PageDetail_textarea"
                id="order_memo"
                maxLength="500"
                rows="10"
                placeholder="메모를 입력해 주세요."
                v-model="formData.orderMemo"
              />
              <br>
              <p>{{ formData.orderMemo.length }}/500</p>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap" v-if="formData.orderCancleRequestStatus !== 0">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='order_cancle_request_status'>결제취소요청</label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="order_cancle_request_status"
                v-model="formData.orderCancleRequestStatus"
              >
                <option value="1">취소요청 처리중</option>
                <option value="2">취소요청 처리완료</option>
              </select>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap" v-if="formData.orderCheckRequestStatus !== 0">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='order_check_request_status'>결제확인요청</label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="order_check_request_status"
                v-model="formData.orderCheckRequestStatus"
              >
                <option value="1">확인요청 처리중</option>
                <option value="2">확인요청 처리완료</option>
              </select>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='order_method_name'>결제 방법<span class="pointTextRed">(수정불가)</span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'order_method_name'
                readonly
                v-model="statusData.orderMethodName"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='order_pay_status_name'>결제 여부<span class="pointTextRed">(수정불가)</span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'order_pay_status_name'
                readonly
                v-model="statusData.orderPayStatusName"
              />
            </div>
            <button v-if="statusData.orderPayStatus === 2" class="Admin_PageDetail_Btn" v-on:click="orderComplete">결제 완료 처리</button>
            <button v-if="statusData.orderPayStatus !== 3" class="Admin_PageDetail_Btn" v-on:click="orderCancel">결제 취소 처리</button>
          </div>

          <div class="Admin_PageInfo pdl15 mgb40" v-if="statusData.orderPayStatus !== 3">
            <p>결제 취소 처리 안내</p>
            <p>1. 결제 취소 시 아래 구매제품의 배송상태는 배송 상태에 따라 바꿔주셔야 합니다.</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap" v-if="statusData.orderPayStatus === 2">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='order_expected_payment_amount'>결제 예정금액</label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'order_expected_payment_amount'
                readonly
                v-model="statusData.orderExpectedPaymentAmount"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.orderExpectedPaymentAmountError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap" v-if="statusData.orderPayStatus === 1">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='order_payment_amount'>결제 완료금액<span class="pointTextRed">(수정불가)</span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'order_payment_amount'
                readonly
                v-model="statusData.orderPaymentAmount"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap" v-if="statusData.orderPayStatus === 3">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='order_cancle_amount'>결제 취소금액<span class="pointTextRed">(수정불가)</span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'order_cancle_amount'
                readonly
                v-model="statusData.orderCancleAmount"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap" v-if="statusData.orderPayStatus === 3">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='order_cancle_date'>결제 취소일자<span class="pointTextRed">(수정불가)</span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'order_cancle_date'
                readonly
                v-model="statusData.orderCancleDate"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap" v-if="statusData.orderMethod === 0 && statusData.orderPayStatus !== 3">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='order_depositor_name'>입금자명<span class="pointTextRed">(수정불가)</span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'order_depositor_name'
                readonly
                v-model="statusData.orderDepositorName"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap" v-if="statusData.orderMethod === 0 && statusData.orderPayStatus !== 3">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='order_cash_receipt_request_name'>현금영수증<span class="pointTextRed">(수정불가)</span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'order_cash_receipt_request_name'
                readonly
                v-model="statusData.orderCashReceiptRequestName"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap" v-if="statusData.orderCashReceiptRequest === 1 && statusData.orderPayStatus !== 3">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='order_cash_receipt_status_name'>구분<span class="pointTextRed">(수정불가)</span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'order_cash_receipt_status_name'
                readonly
                v-model="statusData.orderCashReceiptStatusName"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap" v-if="statusData.orderCashReceiptRequest === 1 && statusData.orderPayStatus !== 3">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='order_cash_receipt_request_number'>요청번호<span class="pointTextRed">(수정불가)</span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'order_cash_receipt_request_number'
                readonly
                v-model="statusData.orderCashReceiptRequestNumber"
              />
            </div>
          </div>

          <div
              class=""
              v-if="formData.buyListData.length !== 0">
              <div class="mallMy_productListBox">
                <p>구입제품정보</p>
                <div
                  class="mallMy_productListBoxInner"
                  v-for="(item, index) in formData.buyListData"
                  :key="index">
                  <div class="pageCartlist_dataMainInfo">
                    <div>
                      <p>{{item.product.product_kor_name}}</p>
                    </div>
                    <p class="pageProductDatail_explainBox_productInfo">
                      <template v-if="item.product.product_discount <= 0">
                        {{formatPrice(item.product.product_sale_price)}}원
                      </template>
                      <template v-else>
                        <div>
                          <p class="dc_origin">{{formatPrice(item.product.product_sale_price)}}원</p>
                          <p class="dc_dcPrice">{{formatPrice(item.product.product_discount)}}원</p>
                        </div>
                      </template>
                    </p>

                    <div class="pageCartlist_dataOption" v-if="item.product_option.length">
                      <div v-if="item.buy_list.product_group_option_name">
                        <p>
                          [{{item.buy_list.product_group_option_title}}] :
                          {{item.buy_list.product_group_option_name}}
                        </p>
                      </div>
                      <div
                        v-for="(option_item, option_index) in item.product_option"
                        :key="option_index">
                        <p>
                          [옵션{{option_index+1}} :
                          {{option_item.product_option_name}}]
                          {{option_item.product_option_list_name}}
                          ({{String(option_item.product_option_list_plus_sale_price).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}원)
                        </p>
                      </div>
                      <p v-if="item.buy_list.product_note">
                        [{{item.buy_list.product_note_title}}] {{item.buy_list.product_note}}
                      </p>
                    </div>
                    <div class="pageProductDatail_explainBox_quantity">
                      <p>수량</p>
                      <div>
                        <p>{{item.buy_list.selling_count}}</p>
                      </div>
                    </div>

                    <div class="Admin_PageDetail_BoxWrap">
                      <div class="Admin_PageDetail_BoxDiv">
                        <label :for="'delivery_progress' + index">배송상태<span class="pointTextRed"> * </span></label>
                        <select
                          class="Admin_PageDetail_inputSelect"
                          :id="'delivery_progress' + index"
                          v-model="item.buy_list.delivery_progress"
                        >
                          <option value="0">배송 준비중</option>
                          <option value="1">배송 중</option>
                          <option value="2">배송 완료</option>
                          <option value="3">배송 취소</option>
                        </select>
                      </div>
                    </div>
                    <div class="pageCartlist_dataTotalPrice">
                      <p>합계</p>
                      <p v-if="item.buy_list.sellingDiscountPrice === 0">{{String(item.buy_list.sellingPrice * item.buy_list.selling_count).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}원</p>
                      <p v-else>{{String(item.buy_list.sellingDiscountPrice * item.buy_list.selling_count).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}원</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import {
  get_order_one,
  update_order,
  update_order_complete,
  update_order_cancle,
  update_order_cancle_card,
  update_recent_buy_list,
  base_url_export
} from '../../ETC/Axios.vue'
import {
  removeWhitespace,
  removeWhitespacePhone,
  validatePhone,
  validateEmail
} from '../../ETC/Validation.vue'

export default {
  name: 'AdminOrderManagementAdd',
  components: {
    AdminHeader: AdminHeader,
    AdminFooter: AdminFooter,
    Spiner: Spiner

  },
  setup () {
    return {
      formData: ref({
        orderReceiveName: '',
        orderZipCode: '',
        orderRoadAddress: '',
        orderDetailAddress: '',
        orderBigArea: '',
        orderSmallArea: '',
        orderPhoneNumber: '',
        orderEmail: '',
        orderMemo: '',
        orderCancleRequestStatus: 0,
        orderCheckRequestStatus: 0,
        buyListData: []
      }),
      errorData: ref({
        orderReceiveNameError: '',
        orderPhoneNumberError: '',
        orderEmailError: ''
      }),
      statusData: ref({
        orderMessage: '',
        orderReceiveNameStatus: false,
        orderPhoneNumberStatus: false,
        orderEmailStatus: true,
        orderMethod: 0,
        orderMethodName: '',
        orderPayStatus: 0,
        orderPayStatusName: '',
        beforeOrderPayStatus: 0,
        orderExpectedPaymentAmount: '',
        orderPaymentAmount: '',
        orderCancleAmount: '',
        orderCancleDate: '',
        imp_uid: '',
        orderDepositorName: '',
        orderCashReceiptRequest: '',
        orderCashReceiptRequestName: '',
        orderCashReceiptStatusName: '',
        orderCashReceiptRequestNumber: '',
        baseUrlExport: base_url_export,
        spinnerStatus: false
      })
    }
  },
  watch: {
    'formData.orderReceiveName': function (value) {
      this.formData.orderReceiveName = removeWhitespace(value)
      if (removeWhitespace(value) === '') {
        this.errorData.orderReceiveNameError = '받는사람은 필수로 입력하셔야 합니다.'
        this.statusData.orderReceiveNameStatus = false
      } else if (removeWhitespace(value).length < 2) {
        this.errorData.orderReceiveNameError = '받는사람은 최소 2자이상 입력하셔야 합니다.'
        this.statusData.orderReceiveNameStatus = false
      } else {
        this.errorData.orderReceiveNameError = ''
        this.statusData.orderReceiveNameStatus = true
      }
    },
    'formData.orderPhoneNumber': function (value) {
      this.formData.orderPhoneNumber = removeWhitespacePhone(value)
      if (removeWhitespacePhone(value) === '') {
        this.errorData.orderPhoneNumberError = '휴대폰번호는 필수로 입력하셔야 합니다.'
        this.statusData.orderPhoneNumberStatus = false
      } else if (validatePhone(removeWhitespacePhone(value))) {
        this.errorData.orderPhoneNumberError = ''
        this.statusData.orderPhoneNumberStatus = true
      } else {
        this.errorData.orderPhoneNumberError = '휴대폰번호 형식으로 입력하셔야 합니다.'
        this.statusData.orderPhoneNumberStatus = false
      }
    },
    'formData.orderEmail': function (value) {
      this.formData.orderEmail = removeWhitespace(value)
      if (removeWhitespace(value) === '') {
        this.errorData.orderEmailError = '이메일은 필수로 입력하셔야 합니다.'
        this.statusData.orderEmailStatus = false
      } else if (validateEmail(removeWhitespace(value))) {
        this.errorData.orderEmailError = ''
        this.statusData.orderEmailStatus = true
      } else {
        this.errorData.orderEmailError = '이메일 형식으로 입력하셔야 합니다.'
        this.statusData.orderEmailStatus = false
      }
    }
  },
  methods: {
    search_address: function () {
      new window.daum.Postcode({
        oncomplete: (data) => {
          this.formData.orderZipCode = data.zonecode
          this.formData.orderRoadAddress = data.roadAddress === '' ? data.autoRoadAddress : data.roadAddress
          this.formData.orderDetailAddress = data.buildingName
          this.formData.orderBigArea = data.sido
          this.formData.orderSmallArea = data.sigungu
        }
      }).open()
    },
    orderComplete () {
      this.statusData.spinnerStatus = true
      update_order_complete(
        this.$route.query.order_ID,
        this.statusData.orderExpectedPaymentAmount.replace(/,/g, '')
      ).then(() => {
        this.statusData.spinnerStatus = false
        this.statusData.orderPaymentAmount = this.statusData.orderExpectedPaymentAmount
        this.statusData.orderExpectedPaymentAmount = '0'
        this.statusData.orderPayStatus = 1
        this.statusData.orderPayStatusName = '완료'
        this.statusData.beforeOrderPayStatus = 1
        alert('결제가 완료되었습니다.')
      })
    },
    async orderCancel () {
      this.statusData.spinnerStatus = true
      if (this.statusData.beforeOrderPayStatus === 1 && this.statusData.orderMethod === 1) {
        update_order_cancle_card(
          this.$route.query.order_ID,
          this.statusData.beforeOrderPayStatus,
          this.statusData.orderPaymentAmount.replace(/\D/g, ''),
          this.statusData.imp_uid
        ).then((result) => {
          if (result.result_code === 0) {
            this.statusData.spinnerStatus = false
            this.statusData.orderPayStatus = 3
            this.statusData.orderPayStatusName = '결제취소'
            this.statusData.orderCancleAmount = this.statusData.orderPaymentAmount
            this.statusData.orderCancleDate = '방금 전'
            alert('결제가 취소되었습니다.')
          } else {
            this.statusData.spinnerStatus = false
            alert(`에러내용 : ${result.error} / 개발자에게 문의해주세요.`)
          }
        })
      } else {
        update_order_cancle(
          this.$route.query.order_ID,
          this.statusData.beforeOrderPayStatus,
          this.statusData.orderPaymentAmount.replace(/\D/g, '')
        ).then(() => {
          this.statusData.spinnerStatus = false
          this.statusData.orderPayStatus = 3
          this.statusData.orderPayStatusName = '결제취소'
          this.statusData.orderCancleAmount = this.statusData.orderPaymentAmount
          this.statusData.orderCancleDate = '방금 전'
          alert('결제가 취소되었습니다.')
        })
      }
    },
    formatPrice (price) {
      return String(Math.floor(price)).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    check_form: function () {
      if (
        this.statusData.orderReceiveNameStatus &&
        this.statusData.orderPhoneNumberStatus &&
        this.statusData.orderEmailStatus
      ) {
        this.statusData.spinnerStatus = true
        const buyListArray = this.formData.buyListData.map(item => item.buy_list)
        update_order(
          this.$route.query.order_ID,
          this.formData.orderReceiveName,
          this.formData.orderZipCode,
          this.formData.orderRoadAddress,
          this.formData.orderDetailAddress,
          this.formData.orderBigArea,
          this.formData.orderSmallArea,
          this.formData.orderPhoneNumber,
          this.formData.orderEmail,
          this.formData.orderMemo,
          this.formData.orderCancleRequestStatus,
          this.formData.orderCheckRequestStatus,
          JSON.stringify(buyListArray)
        ).then(() => {
          this.statusData.spinnerStatus = false
          alert('수정이 완료되었습니다.')
          window.location.href = '/AdminOrderManagement'
        })
      } else {
        alert('필수 입력값을 확인해주세요.')
      }
    }
  },
  mounted () {
    if (this.$route.query.order_ID !== undefined) {
      get_order_one(this.$route.query.order_ID).then((result) => {
        this.formData.orderReceiveName = result[0].order_receive_name
        this.formData.orderZipCode = result[0].order_zip_code
        this.formData.orderRoadAddress = result[0].order_road_address
        this.formData.orderDetailAddress = result[0].order_detail_address
        this.formData.orderBigArea = result[0].order_big_area
        this.formData.orderSmallArea = result[0].order_small_area
        this.formData.orderPhoneNumber = result[0].order_phone_number
        this.formData.orderEmail = result[0].order_email
        this.statusData.orderMessage = result[0].order_message
        this.formData.orderMemo = result[0].order_memo
        this.formData.orderCancleRequestStatus = result[0].order_cancle_request_status
        this.formData.orderCheckRequestStatus = result[0].order_check_request_status
        this.statusData.orderMethod = result[0].order_method
        this.statusData.orderMethodName = result[0].order_method_name
        this.statusData.orderPayStatus = result[0].order_pay_status
        this.statusData.orderPayStatusName = result[0].order_pay_status_name
        this.statusData.beforeOrderPayStatus = result[0].order_pay_status
        this.statusData.orderExpectedPaymentAmount = result[0].order_expected_payment_amount.toLocaleString()
        this.statusData.orderPaymentAmount = result[0].order_payment_amount.toLocaleString()
        this.statusData.orderCancleAmount = result[0].order_cancle_amount.toLocaleString()
        this.statusData.orderCancleDate = result[0].order_cancle_date
        this.statusData.imp_uid = result[0].imp_uid
        this.statusData.orderDepositorName = result[0].order_depositor_name
        this.statusData.orderCashReceiptRequest = result[0].order_cash_receipt_request
        this.statusData.orderCashReceiptRequestName = result[0].order_cash_receipt_request_name
        this.statusData.orderCashReceiptStatusName = result[0].order_cash_receipt_status_name
        this.statusData.orderCashReceiptRequestNumber = result[0].order_cash_receipt_request_number
        update_recent_buy_list(result[0].order_buy_list).then(result_recent_buy_list => {
          this.formData.buyListData = result_recent_buy_list
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/OrderDeliveryManagement/AdminOrderManagementAdd.vue